export default __webpack_public_path__ + "static/media/sz_ShowArea.8e05da21.svg";